import { render } from "./candidats_page.vue?vue&type=template&id=85ae1a06"
import script from "./candidats_page.vue?vue&type=script&lang=js"
export * from "./candidats_page.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__